import { getStoredMainCurrency } from '../utils/currencyFormatUtils';

import { CurrencyIsoTypeEnum } from './pokCore/validation/enums';

export default (
  value: string | number | null,
  isCurrency = false,
  currencyIso?: CurrencyIsoTypeEnum | undefined,
) => {
  const currency = getStoredMainCurrency();
  if (!currency) {
    throw new Error('Brak ustawionej waluty w spółce!');
  }
  const countryCode = currency?.countryCode;
  const currencyCode = currencyIso ?? currency?.currencyCode;

  return value !== null && value !== undefined
    ? isCurrency
      ? Intl.NumberFormat(countryCode, {
          style: 'currency',
          currency: currencyCode,
          useGrouping: true,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(value))
      : Intl.NumberFormat(countryCode).format(Number(value))
    : '';
};
